import { useCallback, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { RouterPaths } from '../../../app/appConstants';
import ButtonCooldown from '../../../components/ButtonCooldown/ButtonCooldown.jsx';
import { forgotPasswordAction } from '../authActions.js';
import { getPasswordForgotErrorSelector, getPasswordForgotSentSelector } from '../authSelectors.js';
import AuthWrapper from './AuthWrapper';
import { LoginStyled } from './styled/LoginStyled';

function Forgot() {
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();

    const [email, setEmail] = useState('');
    const passwordForgotSent = useSelector(getPasswordForgotSentSelector);
    const passwordForgotError = useSelector(getPasswordForgotErrorSelector);

    const submitHandler = useCallback(
        (e) => {
            e.preventDefault();
            const emailValue = e.target.querySelector('[name=email]').value;
            dispatch(forgotPasswordAction({ email: emailValue }));
            setEmail(emailValue);
        },
        [dispatch],
    );

    const resendClickHandler = useCallback(
        (e) => {
            e.preventDefault();
            dispatch(forgotPasswordAction({ email }));
        },
        [email, dispatch],
    );

    return (
        <AuthWrapper>
            <LoginStyled>
                {passwordForgotSent ? (
                    <>
                        <p className="section-eyebrow">{getLangPath('auth.brand')}</p>
                        <h1 className="auth-title">{getLangPath('auth.reset_password.title_sent')}</h1>
                        <p className="auth-subtitle">{getLangPath('auth.reset_password.follow_link')}</p>
                        <div className="auth-actions">
                            <ButtonCooldown
                                successMessage={getLangPath('auth.reset_password.sent_email')}
                                cooldownMessage={getLangPath('auth.reset_password.resend_in')}
                                size="lg"
                                onClick={resendClickHandler}
                            >
                                {getLangPath('auth.reset_password.resend_email')}
                            </ButtonCooldown>
                            <Button variant="outline-info" className="btn-md" as={Link} to={RouterPaths.login}>
                                {getLangPath('auth.reset_password.back_to_login_button')}
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        <p className="section-eyebrow">{getLangPath('auth.brand')}</p>
                        <h1 className="auth-title">{getLangPath('auth.reset_password.title_forgot')}</h1>
                        <p className="auth-subtitle">{getLangPath('auth.reset_password.enter_email')}</p>
                        <Form onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="forgot-email">
                                <Form.Label>{getLangPath('auth.reset_password.email_placeholder')}</Form.Label>
                                <Form.Control
                                    name="email"
                                    type="email"
                                    placeholder={getLangPath('auth.reset_password.email_placeholder')}
                                    required
                                    autoFocus
                                />
                            </Form.Group>

                            {!!passwordForgotError && (
                                <p className="auth-error">{getLangPath(passwordForgotError)}</p>
                            )}

                            <div className="auth-actions">
                                <Button variant="primary" size="lg" type="submit">
                                    {getLangPath('auth.reset_password.submit_button')}
                                </Button>
                                <Button variant="outline-info" className="btn-md" as={Link} to={RouterPaths.login}>
                                    {getLangPath('auth.reset_password.back_to_login_button')}
                                </Button>
                            </div>
                        </Form>
                    </>
                )}
            </LoginStyled>
        </AuthWrapper>
    );
}

export default Forgot;
